import { DeleteOutlined } from '@ant-design/icons';
import { useField } from '@framework/form/field/useField.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Button } from 'antd';
import { i } from 'mathjs';
import { $LabeledSpaceCompact } from '../../../../../../../ui/form/SpaceCompact.ts';
import { type IAsyncService } from '../../../../../../expressions/repository/async/context/IAsyncService.ts';
import { ServiceOutputSelect } from '../ServiceOutputSelect.tsx';

export interface IAsyncSelectServiceColumnConfigProps {
  index: number;
  service: IAsyncService;
  onDelete: () => void;
}

/**
 * Campo di configurazione per la colonna di una tabella di un async select widget.
 */
export function AsyncSelectServiceColumnConfig(
  props: IAsyncSelectServiceColumnConfigProps,
) {
  const { index, service, onDelete } = props;

  const labelField = useField<string | undefined>(
    `table.columns.${index}.label`,
  );

  return (
    <$LabeledSpaceCompact block size="large" key={i}>
      <FormItem name={`table.columns.${index}.value`} label={'Valore'}>
        <ServiceOutputSelect
          service={service}
          name={`table.columns.${index}.value`}
          onChange={(value, _, onChange) => {
            onChange(value);
            if (!labelField.getValue()) {
              labelField.setValue(value);
            }
          }}
        />
      </FormItem>
      <FormItem name={`table.columns.${index}.label`} label={'Etichetta'}>
        <TextInput name={`table.columns.${index}.label`} />
      </FormItem>
      <Button
        onClick={onDelete}
        danger
        icon={<DeleteOutlined aria-label="Rimuovi colonna" />}
      />
    </$LabeledSpaceCompact>
  );
}
